// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_headerContainer__h3AdH {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: var(--pure-white-color);
  padding: 0 1rem;
  height: 80px;
  width: 100%;
  position: fixed;
  inset: 0;
  z-index: 100;
  box-shadow: var(--default-box-shadow);
}
.Navbar_headerContainer__h3AdH .Navbar_logoContainer__NJRZQ {
  display: flex;
  margin: 5px 0px 5px 5px;
  padding: 5px;
}
.Navbar_headerContainer__h3AdH .Navbar_searchContainer__ms6pj {
  width: 271px;
  margin: auto;
}

.Navbar_notificationDropDown__kxmMj {
  overflow-y: scroll;
  max-height: 280px;
  width: 550px;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.Navbar_noNotifcation__ksRaG {
  width: 180px;
}

.Navbar_notificationContainer__8L0sE {
  display: flex;
  margin-right: 20px;
}
.Navbar_notificationContainer__8L0sE .Navbar_badgeContainer__CH7ij {
  min-width: 25px;
  text-align: center;
}
.Navbar_notificationContainer__8L0sE .Navbar_notificationContent__xDknE {
  min-width: 250px;
}
.Navbar_notificationContainer__8L0sE .Navbar_notificationContent__xDknE .Navbar_notificationTitle__mjRnp {
  font-weight: 600;
  font-size: 16px;
}
.Navbar_notificationContainer__8L0sE .Navbar_notificationContent__xDknE .Navbar_notificationDescription__wvUwS {
  font-weight: 400;
  font-size: 14px;
  color: rgb(130, 130, 130);
}
.Navbar_notificationContainer__8L0sE .Navbar_notificationContent__xDknE .Navbar_notificationDate__fjDND {
  font-weight: 400;
  font-size: 12px;
  color: rgb(130, 130, 130);
}`, "",{"version":3,"sources":["webpack://./src/component/common/navbar/Navbar.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,qCAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AACJ;AAEE;EACE,YAAA;EACA,YAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;AADJ;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,aAAA;EACA,kBAAA;AADF;AAEE;EACE,eAAA;EACA,kBAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ;AACI;EACE,gBAAA;EACA,eAAA;AACN;AACI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AACN;AACI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AACN","sourcesContent":[".headerContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: var(--pure-white-color);\n  padding: 0 1rem;\n  height: 80px;\n  width: 100%;\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  box-shadow: var(--default-box-shadow);\n\n  .logoContainer {\n    display: flex;\n    margin: 5px 0px 5px 5px;\n    padding: 5px;\n  }\n\n  .searchContainer {\n    width: 271px;\n    margin: auto;\n  }\n}\n\n.notificationDropDown {\n  overflow-y: scroll;\n  max-height: 280px;\n  width: 550px;\n  -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n\n}\n.noNotifcation {\n  width: 180px;\n}\n\n.notificationContainer {\n  display: flex;\n  margin-right: 20px;\n  .badgeContainer {\n    min-width: 25px;\n    text-align: center;\n  }\n  .notificationContent {\n    min-width: 250px;\n    .notificationTitle {\n      font-weight: 600;\n      font-size: 16px;\n    }\n    .notificationDescription {\n      font-weight: 400;\n      font-size: 14px;\n      color: rgb(130, 130, 130);\n    }\n    .notificationDate {\n      font-weight: 400;\n      font-size: 12px;\n      color: rgb(130, 130, 130);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `Navbar_headerContainer__h3AdH`,
	"logoContainer": `Navbar_logoContainer__NJRZQ`,
	"searchContainer": `Navbar_searchContainer__ms6pj`,
	"notificationDropDown": `Navbar_notificationDropDown__kxmMj`,
	"noNotifcation": `Navbar_noNotifcation__ksRaG`,
	"notificationContainer": `Navbar_notificationContainer__8L0sE`,
	"badgeContainer": `Navbar_badgeContainer__CH7ij`,
	"notificationContent": `Navbar_notificationContent__xDknE`,
	"notificationTitle": `Navbar_notificationTitle__mjRnp`,
	"notificationDescription": `Navbar_notificationDescription__wvUwS`,
	"notificationDate": `Navbar_notificationDate__fjDND`
};
export default ___CSS_LOADER_EXPORT___;
